var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "draughts skew-11-neg"
  }, [_c('div', {
    staticClass: "text-section"
  }, [_c('div', {
    staticClass: "text-section-title"
  }, [_vm._v("Ancient Brain Draughts Game")]), _vm._v(" "), _c('div', {
    staticClass: "text-section-content"
  }, [_vm._v("\n      As part of my B.Sc. studies at "), _c('a', {
    attrs: {
      "href": "https://www.dcu.ie/",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("DCU")]), _vm._v(" I created a basic draughts game using JavaScript with the "), _c('a', {
    attrs: {
      "href": "https://threejs.org/",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("Three.js")]), _vm._v(" library. I wrote this as a submission to a website created by "), _c('a', {
    attrs: {
      "href": "https://computing.dcu.ie/~humphrys/",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("Dr. Mark Humphrys")]), _vm._v(" called "), _c('a', {
    attrs: {
      "href": "https://ancientbrain.com/",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("Ancient Brain")]), _vm._v(" which allows people to share coding projects in the form of \"Worlds\" and \"Minds\". The game can be played "), _c('a', {
    attrs: {
      "href": "https://run.ancientbrain.com/run.php?world=8392146989&mind=5349637596",
      "target": "_blank",
      "rel": "noreferrer nofollow"
    }
  }, [_vm._v("here on Ancient Brain")]), _vm._v("!\n    ")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdf2e286","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Draughts.vue
// module id = cqfn
// module chunks = 0